/*
 * Copyright © 2020-2023 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: yongqiang
 * @LastEditTime: 2023-12-08 15:00:28
 */
/* eslint-disable no-undef */
import './index.scss'
import React, { useRef, useEffect } from 'react'
import { Layout } from 'antd'
import { useNavigate } from 'react-router-dom'
import { Grid } from 'react-virtualized'
import Filter from './Filter'
import PhotosList from './PhotosList'
import { AIPhotoProvider } from './hooks/Context'
import { useAppSelector } from '../../app/hooks'

const { Content } = Layout

const AIPhoto = () => {
  const photoListRef = useRef<Grid>(null)
  const navigate = useNavigate()
  const groupID = useAppSelector((state) => state.group.groupId)
  const aiPhotoTagsState = useAppSelector((state) => state.group.aiPhotoTags)

  useEffect(() => {
    if (!aiPhotoTagsState) return
    const { loaded, count, groupId: tagsGroupId } = aiPhotoTagsState
    if (loaded && count > 0 && tagsGroupId === groupID) {
      navigate('/photo/ai-tags', { replace: true })
    }
  }, [aiPhotoTagsState, groupID, navigate])

  return (
    <Layout className="AIPhotos">
      <Content className="content">
        <Filter />
        <PhotosList ref={photoListRef} />
      </Content>
    </Layout>
  )
}

const AIPhotoPage = () => {
  return (
    <AIPhotoProvider>
      <AIPhoto />
    </AIPhotoProvider>
  )
}

export default AIPhotoPage
